import { Lang, LangObject } from '@brg/api';

export type ProjectAiSummaryValue = string | LangObject[] | null | undefined;

/** Текст ИИ-саммари проекта для текущего языка (поле aiSummary с API). */
export const getProjectAiSummary = (aiSummary: ProjectAiSummaryValue, lang: string): string => {
    if (!aiSummary) {
        return '';
    }
    if (typeof aiSummary === 'string') {
        return aiSummary.trim();
    }
    if (!Array.isArray(aiSummary) || aiSummary.length === 0) {
        return '';
    }
    return (Lang(aiSummary, lang) || '').trim();
};
import { Lang, LangObject } from '@brg/api';

export type ProjectAiSummaryValue = string | LangObject[] | null | undefined;

/** Текст ИИ-саммари проекта для текущего языка (поле aiSummary с API). */
export const getProjectAiSummary = (aiSummary: ProjectAiSummaryValue, lang: string): string => {
    if (!aiSummary) {
        return '';
    }
    if (typeof aiSummary === 'string') {
        return aiSummary.trim();
    }
    if (!Array.isArray(aiSummary) || aiSummary.length === 0) {
        return '';
    }
    return (Lang(aiSummary, lang) || '').trim();
};
